export default __webpack_public_path__ + "static/media/suit-jacket.a98e5842.png";